import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M23.0999 1.31997C30.6899 0.37997 32.94 5.16006 32.94 5.16006C32.94 5.16006 35.7799 4.63 38.0999 6.85C40.0199 8.69 40.91 12.86 38.76 17.82C35.01 26.45 16.91 28.6 13.26 16.98C11.29 10.73 14.5899 2.36997 23.0999 1.31997Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M32.52 4.68994C32.52 4.68994 34.06 9.45994 29.2 17.0599" stroke={outline} strokeMiterlimit="10" />
      <path d="M38.0999 7.18994C38.0999 7.18994 40.04 11.96 31.95 17.54" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M26.2901 1.44995C26.2901 1.44995 23.5401 2.81995 26.1301 16.8199"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path d="M20.79 2.02002C20.79 2.02002 16.99 5.25 22.16 17.63" stroke={outline} strokeMiterlimit="10" />
      <path d="M18.2 2.82996C18.2 2.82996 15.21 10.19 20.79 17.95" stroke={outline} strokeMiterlimit="10" />
      <path d="M13.59 8.16003C13.59 8.16003 12.2199 14.63 19.4899 18.67" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M47.15 27.4C42.61 20.64 32.36 16.64 26.41 16.64C20.45 16.64 10.11 20.64 5.58002 27.4C-2.54998 39.51 2.99 60.64 2.99 60.64C2.99 60.64 3.54002 36.4299 9.64002 30.0499C14.83 24.6099 19.6 29.33 26.36 29.33C33.13 29.33 37.89 24.6199 43.08 30.0499C49.18 36.4399 49.73 60.64 49.73 60.64C49.73 60.64 55.28 39.51 47.15 27.4Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M20.84 17.88C20.84 17.88 18.76 17.32 21.67 29.37" stroke={outline} strokeMiterlimit="10" />
      <path d="M14.4701 20.35C14.4701 20.35 11.3101 21.44 13.6401 27.99" stroke={outline} strokeMiterlimit="10" />
      <path d="M11.5601 22.17C11.5601 22.17 7.40007 23.3 8.93007 31.13" stroke={outline} strokeMiterlimit="10" />
      <path d="M5.28002 28.0599C5.28002 28.0599 0.610013 33.17 4.77001 44.89" stroke={outline} strokeMiterlimit="10" />
      <path d="M31.8701 17.88C31.8701 17.88 33.95 17.32 31.04 29.37" stroke={outline} strokeMiterlimit="10" />
      <path d="M38.25 20.35C38.25 20.35 41.25 21.15 39.08 27.99" stroke={outline} strokeMiterlimit="10" />
      <path d="M41.1602 22.17C41.1602 22.17 45.2602 23.11 43.7902 31.13" stroke={outline} strokeMiterlimit="10" />
      <path d="M47.4399 28.0599C47.4399 28.0599 52.11 33.17 47.95 44.89" stroke={outline} strokeMiterlimit="10" />
    </g>
  )
}
